/**
 * Authorization Roles
 */
const authRoles = {
	admin: ['company_owner', 'super_admin', 'product_owner'],
	subadmin: ['school_admin', 'super_school_admin', 'sub_admin'],
};

export default authRoles;
